import { render, staticRenderFns } from "./suola-fits.vue?vue&type=template&id=7bbc8756&scoped=true&"
import script from "./suola-fits.vue?vue&type=script&lang=js&"
export * from "./suola-fits.vue?vue&type=script&lang=js&"
import style0 from "./suola-fits.vue?vue&type=style&index=0&id=7bbc8756&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbc8756",
  null
  
)

export default component.exports